import { ActivityData } from "../../route/developer/activities";
import { StandardSpecificData } from "../../route/shared/projects/project/overview/components/StandardSpecificSection/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const constructContext = (data: ActivityData | StandardSpecificData): any => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const res: any = {};
  if (data.data !== undefined) {
    Object.keys(data.data).forEach((key) => {
      if (!data.data || data.data[key] === undefined) return;
      const val = data.data[key];
      if (val?.children) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const repeaterValues: any[] = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        val.children.forEach((repeaterItem: any) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const repeaterValue: any = {};
          Object.keys(repeaterItem).forEach((rk) => {
            repeaterValue[rk] = repeaterItem[rk];
          });
          repeaterValues.push(repeaterValue);
        });
        res[key] = repeaterValues;
      } else {
        res[key] = val;
      }
    });
  } else if (data.steps && data.steps.length) {
    data.steps.forEach((item) => {
      res[item.key] = constructContext(item);
    });
  }
  return res;
};
